export const StateEnum = Object.freeze({
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED',
  CURRENT: 'CURRENT',
});
